var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"card-revenue-budget",attrs:{"no-body":""}},[_c('vue-apex-charts',{attrs:{"id":"revenue-report-chart","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }